import { ParentContext } from 'global/cnr/contexts/ParentContext';
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { seasonalDataHelpers, seasonalUpdateTypes } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { seasonalHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers';
import { getLevelMatchez } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonSportsData';
import { useMatchUpdate } from 'projectSpecific/sports/useHelpers/useMatchUpdate';
import { useSeasonalDataHelpers } from 'projectSpecific/sports/useHelpers/useSeasonalDataHelpers';
import { _allowSportsUpdates, useSeasonalData } from 'projectSpecific/sports/useHelpers/useSeasonals';;
import React, { useContext, useEffect, useMemo } from 'react'

export const MatchPendings = () => {

  const parentContext = useContext(ParentContext)
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainRt, mainDb } = app_state
  const { database_fns } = fns ?? {}

  // sportsDistrictContext
  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data, sportPermissions } = sportsDistrict_state ?? {}
  const { gls_scores } = district_data ?? {}
  const gls_score = gls_scores?.[pathViews?.sports]
  const { scoreEmails } = gls_score ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info, sportSettings_info, currentSeason_info } = sportsSeason_state ?? {};
  const { matchPlayoffPendings } = matches_info ?? {};
  const { useScoringCollection, useScoringCollectionOnly } = sportSettings_info ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  // const { updateMatchesSeasonal_byLevel, updating } = useMatchUpdate()
  const { updateMatchesSeasonal_byLevel, updating } = useSeasonalDataHelpers()
  const { getSports_collectionItem } = seasonalDataHelpers(mainDb, database_fns, pathViews)

  const _matchPlayoffPendings = useMemo(() => {
    return _.fromPairs(_.reverse(_.toPairs(_.groupBy(matchPlayoffPendings, '_matchCollectionKey'))));

  })

  // useEffect(() => {
  //   const cb = (res) => {
  //     // clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/_matches_seasonal/MVB_2026_YzZhvmotOHlY3ePS8QJj/playoffMatches/3A
  //     // clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/_matches_seasonal/MVB_2026_YzZhvmotOHlY3ePS8QJj/playoffMatches/2A
  //   }
  //   const pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['teams'])
  //   getSports_collectionItem(pks, '_matches_seasonal', true, null, cb)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const { _levelUpdateMatches } = getLevelMatchez(matchPlayoffPendings)

  const handleUpdatePendings = () => {
    const cb = () => { }
    const _updateProps = {
      callback: cb,
      dataToUpdate: _.cloneDeep(_levelUpdateMatches),
      forPlayoffs: true,
      pathViews,
      pks: seasonalHelpers.getPks(pathViews, latestSeason, sportsKey),
      seasonalUpdateType: seasonalUpdateTypes.matchesList,
      sportPermissions,
      useScoringCollection,
      useScoringCollectionOnly,
    }
    updateMatchesSeasonal_byLevel(_updateProps)
  }

  const fnSub = (match) => {
    const { pending } = match ?? {}
    const { away, home } = pending ?? {}
    const { name: away_name } = away ?? {}
    const { name: home_name } = home ?? {}
    if (away_name && home_name) {
      return <div>{`${away_name} - ${home_name}`}</div>
    } else {
      return <div>{`${away_name} - Bye`}</div>
    }

  }

  const content_levels = () => {
    if (_.isEmpty(_matchPlayoffPendings)) return <div>No Pending Matches</div>
    const mps = []
    _.forEach(_matchPlayoffPendings, (ms, key) => {
      mps.push(<div>
        <div className='level-header'>{key}</div>
        <ItemMenuSquares
          icon={'cog'}
          menuItems={ms}
          imsType={_imsTypes.matchFull}
          fn_beforeContent={fnSub}
        />
      </div>
      )
    })
    return mps
  }

  return <Wrapper
    content={content_levels()}
    footer={<UiSaveButtons
      save={{
        oc: handleUpdatePendings,
        color: _allowSportsUpdates.matches ? 'green' : 'teal',
        caption: 'Update Pending Matches'
      }}
    />}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ content: 'scoreboard' }}
  ></Wrapper>
}
